/**
 * <PresenceHeartbeat /> (R100.56, 2026-05-30)
 *
 * Mount-once-per-app-Komponente, die alle 60 s POST /api/me/heartbeat ruft —
 * nur wenn der Tab fokussiert ist und der User eingeloggt ist. Stoppt im
 * Hintergrund-Tab, um unnötige Server-Last zu vermeiden.
 *
 * Datensparsam: kein Tracking, keine Telemetrie, kein Cookie — nur ein
 * server-seitiges last_seen_at-Timestamp wird gesetzt.
 */

'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

const INTERVAL_MS = 60_000

export function PresenceHeartbeat() {
  const { status } = useSession()

  useEffect(() => {
    if (status !== 'authenticated') return
    let aborted = false
    let timer: number | undefined

    async function ping() {
      if (aborted || document.hidden) return
      try {
        await fetch('/api/me/heartbeat', { method: 'POST', credentials: 'same-origin' })
      } catch {
        // Verbindung weg → einfach nichts. Nächster Tick versucht erneut.
      }
    }

    ping()
    timer = window.setInterval(ping, INTERVAL_MS)

    const onVisibility = () => {
      if (!document.hidden) ping()
    }
    document.addEventListener('visibilitychange', onVisibility)

    return () => {
      aborted = true
      if (timer) window.clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [status])

  return null
}
